module.exports = __webpack_public_path__ + "static/media/sf-test-5.afa31966.mp3";